import React from "react";
import { Container, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";

interface RouteInfoProps {
  info: {
    EventLocation: string;
    ReturnLocation: string;
    TimeRequired: string;
    ETA?: string;
  };
}

const useStyles = makeStyles({
  routeInfo: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    marginTop: "29px",
  },
});

const theme = createMuiTheme({
  overrides: {
    MuiTypography: {
      root: {
        fontFamily: "Lato",
      },
      body2: {
        fontFamily: "Lato",
        textTransform: "uppercase",
        fontSize: "14px",
        fontWeight: 700,
        color: "#ffffff50",
        marginBottom: "7px",
        display: "block",
      },
      body1: {
        fontFamily: "Lato",
        fontSize: "21px",
        fontWeight: 700,
        color: "#fff",
        display: "block",
        marginBottom: "27px",
      },
    },
  },
});

const RouteInfo: React.FC<RouteInfoProps> = (props) => {
  const classes = useStyles();
  const { info } = props;
  return (
    <ThemeProvider theme={theme}>
      <Container className={classes.routeInfo}>
        <Typography variant="body2">EVENT LOCATION</Typography>
        <Typography variant="body1">{info.EventLocation}</Typography>

        <Typography variant="body2">RETURN LOCATION</Typography>
        <Typography variant="body1">{info.ReturnLocation}</Typography>

        <Typography variant="body2">TIME REQUIRED ON SITE</Typography>
        <Typography variant="body1">{info.TimeRequired}</Typography>

        {info.ETA && (
          <>
            <Typography variant="body2">ETA</Typography>
            <Typography variant="body1">{info.ETA}</Typography>
          </>
        )}
      </Container>
    </ThemeProvider>
  );
};

export default RouteInfo;
